<template>
  <div class="AgreementPdf">
    <h1 class="m-label">家庭ファイル</h1>
    <!-- <tr&#45;c slot="tr&#45;th"> -->
    <!--   <th&#45;c>id</th&#45;c> -->
    <!--   <th&#45;c>family_id</th&#45;c> -->
    <!--   <th&#45;c>user_id</th&#45;c> -->
    <!--   <th&#45;c>ファイル名</th&#45;c> -->
    <!--   <th&#45;c>作成日</th&#45;c> -->
    <!-- </tr&#45;c> -->
    <!-- <tr&#45;c slot="tr&#45;td"> -->
    <!--   <td&#45;c>{{familyfile.id}}</td&#45;c> -->
    <!--   <td&#45;c>{{familyfile.family_id}}</td&#45;c> -->
    <!--   <td&#45;c>{{familyfile.user_id}}</td&#45;c> -->
    <!--   <td&#45;c>{{familyfile.file_name}}</td&#45;c> -->
    <!--   <td&#45;c>{{familyfile.created_at}}</td&#45;c> -->
    <!-- </tr&#45;c> -->

    <div class="m-box__inner">
      <template v-if="agreement.student">
        <div class="pdfs" v-for="(list, index) in agreement.student.family.familyfiles" :key="list.id">
          <h1 class="m-label pdf-li" @click="isShow(list.id)">PDF {{index+1}}</h1>
          <template v-if="list.id === listId">
            <iframe v-bind:src="files + list.id + '_f.pdf'" frameborder="0"></iframe>
          </template>
        </div>
      </template>
    </div>
    <btn>ファイル</btn>
  </div>
</template>

<script>
import { getFILE } from '@/store/getters.js'
const files = getFILE()

export default {
  props: {
    agreement: Object,
    type: String,
    edit_id: Object
  },
  data () {
    return {
      files: files,
      listId: ''
    }
  },
  computed: {
    // familyfile () {
    //   return this.$store.getters.familyfile
    // }
  },
  methods: {
    isShow (val) {
      if (this.listId !== val) {
        this.listId = val
      } else {
        this.listId = ''
      }
    }
    // getFamilyfile (id) {
    //   this.$store.dispatch('getFamilyfile', {
    //     id: id
    //   })
    // }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // vm.getFamilyfile(to.params.id)
    })
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang="scss" scoped>
iframe {
  width: 100%;
  height: calc(100vh - 185px);
  padding: 1rem;
}
.pdfs {
  overflow: auto;
}
.m-label {
  margin: 0;
}
.pdf-li {
  cursor: pointer;
}
.m-box__inner {
  height: calc(100vh - 262px);
  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// AgreementPdf.vue?0856c3b6